import Loader from "./loader.es6";
import CharaChange from "./charachange.es6";

export default class Top {

    constructor() {
        this._init();
    }

    _init() {
        this.CharaChange = new CharaChange();
        this.Loader = new Loader();
    }
}
